import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TRequestWorkerPaycardsRequest } from "./requestContractorPaycards.schema";

export const requestContractorPaycards = (axios: IAxiosInstance) => {
  return async ({ workerId, ...data }: TRequestWorkerPaycardsRequest) => {
    const response = await axios.noRetry.post(
      `/api/contractors/${workerId}/paycards/request`,
      data
    );

    return response; // returns 204 no data
  };
};
